/* =====================================================================
   Rumble & Rest — theme script

   What is deliberately NOT in this file any more:

   - A hard-coded REVIEWS array of six invented customers with invented pet
     names, invented cities and "Verified purchase" badges, plus a DIST array
     asserting "186 reviews, 4.8 average". All of it fabricated. Publishing
     that is a banned practice under the UK's DMCC Act 2024 and the FTC's
     fake-review rule. Reviews now come only from real data.
   - The store FAQ, which lived here as a JS array and was injected into an
     empty div. Search engines were served an empty div. It is Liquid now
     (snippets/site-faq.liquid) and ships in the HTML.
   ===================================================================== */

const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

/* ---------------------------------------------------------------
   Accordions — one initialiser for every .faq__b on the page,
   wherever it was rendered from.
   --------------------------------------------------------------- */
function initAccordions(root = document) {
  $$('.faq__b, .acc__b', root).forEach(btn => {
    if (btn.dataset.bound) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.dataset.bound = '1';
    panel.style.height = '0px';
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
    });
    addEventListener('resize', () => {
      if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = panel.scrollHeight + 'px';
    });
  });
}

/* ---------------------------------------------------------------
   Mobile menu: focus trap, Escape, scroll lock, focus return
   --------------------------------------------------------------- */
function initMenu() {
  const burger = $('#burger'), panel = $('#menu');
  if (!burger || !panel) return;
  let lastFocus = null;
  const focusables = () => $$('a[href], button:not([disabled])', panel).filter(el => el.offsetParent !== null);

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(); if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function open() {
    lastFocus = document.activeElement;
    panel.dataset.open = 'true';
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-locked');
    focusables()[0]?.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (panel.dataset.open !== 'true') return;
    panel.dataset.open = 'false';
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-locked');
    document.removeEventListener('keydown', onKey);
    (lastFocus || burger).focus();
  }
  burger.addEventListener('click', open);
  panel.addEventListener('click', e => {
    if (e.target.closest('[data-close]') || e.target.closest('a[href]')) close();
  });
}

initAccordions();
initMenu();

/* ---------------------------------------------------------------
   Product page: gallery thumbs + variant selection
   --------------------------------------------------------------- */
(function () {
  const q  = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];

  /* gallery */
  const main = q('#gal-main'), thumbs = q('#thumbs');
  if (main && thumbs) {
    const btns = qa('.gal__t', thumbs);
    const pick = i => {
      main.src = btns[i].dataset.src;
      main.removeAttribute('srcset');   /* the thumb gives one fixed URL; a stale srcset would win */
      main.alt = btns[i].dataset.alt || '';
      btns.forEach((b, n) => {
        b.setAttribute('aria-selected', String(n === i));
        b.tabIndex = n === i ? 0 : -1;
      });
    };
    thumbs.addEventListener('click', e => {
      const b = e.target.closest('.gal__t');
      if (b) pick(btns.indexOf(b));
    });
    thumbs.addEventListener('keydown', e => {
      if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      e.preventDefault();
      const cur = btns.findIndex(b => b.getAttribute('aria-selected') === 'true');
      const nxt = e.key === 'ArrowRight'
        ? (cur + 1) % btns.length : (cur - 1 + btns.length) % btns.length;
      pick(nxt); btns[nxt].focus();
    });
  }

  /* variants — option buttons drive the hidden select Shopify submits */
  const sel = q('#variant-select');
  if (sel) {
    const chosen = [];
    qa('.opt').forEach(b => {
      if (b.getAttribute('aria-pressed') === 'true') chosen[+b.dataset.option - 1] = b.dataset.value;
    });
    const sync = () => {
      const want = chosen.filter(Boolean).join(' / ');
      const opt = [...sel.options].find(o => (o.dataset.title || '').trim() === want);
      if (!opt) return;
      sel.value = opt.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      const now = q('#price-now'), add = q('#add-price');
      if (now && opt.dataset.price) now.textContent = opt.dataset.price;
      if (add && opt.dataset.price) add.textContent = opt.dataset.price;
    };
    qa('.opt').forEach(btn => btn.addEventListener('click', () => {
      chosen[+btn.dataset.option - 1] = btn.dataset.value;
      qa(`.opt[data-option="${btn.dataset.option}"]`).forEach(x =>
        x.setAttribute('aria-pressed', String(x === btn)));
      sync();
    }));
  }
})();

/* ---------------------------------------------------------------
   Product page: sticky buy bar
   --------------------------------------------------------------- */
(function () {
  const bar = document.getElementById('sticky');
  const cta = document.querySelector('.btn--buy');
  if (!bar || !cta) return;

  let queued = false;
  const update = () => { queued = false; bar.dataset.show = String(cta.getBoundingClientRect().bottom < 0); };
  const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  update();

  document.getElementById('sticky-add')?.addEventListener('click', () => cta.click());

  const sel = document.getElementById('variant-select');
  const sp  = document.getElementById('sticky-price');
  if (sel && sp) {
    sel.addEventListener('change', () => {
      const o = sel.options[sel.selectedIndex];
      if (o?.dataset.price) sp.textContent = o.dataset.price;
    });
  }
})();

/* ---------------------------------------------------------------
   Dispatch cutoff.

   Genuine time left, read in Europe/London — the timezone the copy actually
   names. The previous version used the visitor's own clock, so a customer in
   Los Angeles was told they had five hours left against a "2pm" cutoff that
   had passed in the UK before they woke up. No fake countdown, no reset loop:
   if the cutoff has gone, it says so.
   --------------------------------------------------------------- */
(function () {
  const msg = document.getElementById('rush-msg');
  const rush = msg?.closest('.rush');
  const cut = parseInt(rush?.dataset.cutoff ?? '', 10);
  if (!msg || Number.isNaN(cut)) return;

  let parts;
  try {
    parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
  } catch { return; }              /* no Intl/tz data: keep the server-rendered sentence */

  const get = t => parts.find(p => p.type === t)?.value;
  const day = get('weekday');
  const h = parseInt(get('hour'), 10);
  const m = parseInt(get('minute'), 10);
  if (Number.isNaN(h) || Number.isNaN(m)) return;

  const pad = n => String(n).padStart(2, '0');
  const label = `${pad(cut)}:00`;

  if (day === 'Sat' || day === 'Sun') {
    msg.textContent = `Order before ${label} UK time on Monday and it goes out the same day`;
    return;
  }
  if (h >= cut) {
    const next = day === 'Fri' ? 'Monday' : 'tomorrow';
    msg.textContent = `Today's post has gone. Order before ${label} UK time ${next} and it goes out the same day`;
    return;
  }
  const mins = (cut * 60) - (h * 60 + m);
  const left = mins >= 60 ? `${Math.floor(mins / 60)}h ${mins % 60}m` : `${mins} minutes`;
  msg.innerHTML = `<b>${left}</b> left to have it dispatched today`;
})();

/* ---------------------------------------------------------------
   Review carousel — reads the product's `reviews` metafield
   (window.__productReviews). Renders nothing when there are none.
   --------------------------------------------------------------- */
(function () {
  const track = document.getElementById('rev-track');
  const root  = document.getElementById('rev-carousel');
  const REVIEWS = Array.isArray(window.__productReviews) ? window.__productReviews : [];
  if (!track || !root || !REVIEWS.length) return;

  const esc = s => String(s ?? '').replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const stars = n => '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  const N = REVIEWS.length;
  document.getElementById('rev-total').textContent = String(N).padStart(2, '0');

  const slide = (r, clone) => `
    <li class="carousel__slide"${clone ? ' aria-hidden="true"' : ''}>
      <article class="rcard">
        ${r.img
          ? `<img class="rcard__img" src="${esc(r.img)}" alt="" width="600" height="375" loading="lazy">`
          : `<div class="rcard__ph" aria-hidden="true"><span>${esc((r.name || '?').trim()[0])}</span></div>`}
        <div class="rcard__s" aria-hidden="true">${stars(r.stars)}</div>
        <p class="sr-only">Rated ${esc(r.stars)} out of 5</p>
        <p class="rcard__t">${esc(r.text)}</p>
        <footer class="rcard__f">
          <b>${esc(r.name)}</b>
          <span class="rcard__v"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4.5 4.5L19 7"/></svg>Verified purchase</span>
          <span>${esc([r.location, r.pet || r.dog].filter(Boolean).join(' · '))}</span>
        </footer>
      </article>
    </li>`;

  track.innerHTML = REVIEWS.map(r => slide(r, false)).join('')
                  + REVIEWS.map(r => slide(r, true)).join('');

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const SPEED = 20;
  let offset = 0, step = 0, setW = 0, target = null;
  let paused = false, dragging = false, last = 0;

  function measure() {
    const first = track.querySelector('.carousel__slide');
    if (!first) return;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    step = first.getBoundingClientRect().width + gap;
    setW = step * N;
    offset = ((offset % setW) + setW) % setW;
    apply();
  }
  const apply = () => { track.style.transform = `translate3d(${-offset}px,0,0)`; };
  const index = () => ((Math.round(offset / step) % N) + N) % N;

  function frame(now) {
    const dt = last ? (now - last) / 1000 : 0;
    last = now;
    if (target !== null) {
      offset += (target - offset) * Math.min(1, dt * 9);
      if (Math.abs(target - offset) < 0.6) { offset = target; target = null; }
    } else if (!paused && !dragging && !reduced.matches) {
      offset += SPEED * dt;
    }
    if (setW) {
      if (offset >= setW) { offset -= setW; if (target !== null) target -= setW; }
      if (offset < 0)     { offset += setW; if (target !== null) target += setW; }
    }
    apply();
    document.getElementById('rev-pos').textContent = String(index() + 1).padStart(2, '0');
    requestAnimationFrame(frame);
  }

  function go(dir) {
    target = (target === null ? offset : target) + dir * step;
    const i = ((Math.round(target / step) % N) + N) % N;
    document.getElementById('rev-live').textContent = `Review ${i + 1} of ${N}`;
  }
  document.getElementById('rev-prev').addEventListener('click', () => go(-1));
  document.getElementById('rev-next').addEventListener('click', () => go(1));
  root.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
  });

  root.addEventListener('mouseenter', () => paused = true);
  root.addEventListener('mouseleave', () => paused = false);
  root.addEventListener('focusin',  () => paused = true);
  root.addEventListener('focusout', () => { if (!root.contains(document.activeElement)) paused = false; });
  document.addEventListener('visibilitychange', () => paused = document.hidden);

  let startX = 0, startOffset = 0;
  track.addEventListener('pointerdown', e => {
    dragging = true; target = null;
    startX = e.clientX; startOffset = offset;
    track.classList.add('is-drag'); track.setPointerCapture(e.pointerId);
  });
  track.addEventListener('pointermove', e => { if (dragging) offset = startOffset - (e.clientX - startX); });
  const endDrag = () => {
    if (!dragging) return;
    dragging = false; track.classList.remove('is-drag');
    target = Math.round(offset / step) * step;
  };
  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);

  addEventListener('resize', measure);
  measure();
  requestAnimationFrame(frame);
})();
